import { Component, Input } from '@angular/core';

@Component({
  selector: 'simple-card',
  templateUrl: './simple-card.component.html',
  styleUrl: './simple-card.component.scss'
})
export class SimpleCardComponent {
  @Input() cardTitle?: string;
  @Input() showHeader = true;
  @Input() id?: string;
  @Input() className?: string;
  @Input() contentLayout: 'default' | 'flex-wrap' = 'default';
  @Input() titleFontSize?: string;
  @Input() enableShadow = false;
  @Input() backgroundImage?: string;

  getCardClasses(): Record<string, boolean> {
    const classes: Record<string, boolean> = {};

    if (this.className) {
      classes[this.className] = true;
    }

    classes['card-shadow'] = this.enableShadow;
    classes['card-background'] = !!this.backgroundImage;

    return classes;
  }
}
